import React from "react";
import PropTypes from "prop-types";

import Typography from "@mui/material/Typography";

import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { DATA_SOURCE } from "../../../../../util/Data/DataModeling";
import Alert from "@mui/material/Alert";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const ThirdStepComponent = ({ openConfirm }) => {
  return (
    <>
      <Typography component="span" sx={{ marginTop: "10px", padding: "0" }}>
        Are you sure you want to apply configuration to data warehouse?
      </Typography>
      {openConfirm.tableDeletion && (
        <Alert
          icon={<WarningAmberRoundedIcon color="error" fontSize="large" />}
          sx={{
            mt: 1,
            mb: 2,
            padding: "0",
            paddingRight: "5px",
            paddingLeft: "5px",
            backgroundColor: "#ffe6e6",
            display: "flex",
            alignItems: "center",
            textAlign: "center",
          }}
          variant="outlined"
          severity="error"
        >
          {`Key column(s) and/or ${DATA_SOURCE.singular.toLowerCase()}
            reference(s) updated, this will result in losing the impacted table(s) and data. The deleted data is irreversible.`}
        </Alert>
      )}
      {openConfirm.columnDeletion && (
        <Typography component="span" fontWeight="bold" sx={{ display: "flex" }}>
          <ReportProblemIcon fontSize="small" color="warning" sx={{ mr: 1 }} /> Column(s) deleted, this will result in
          losing the columns from the Satellite tables.
        </Typography>
      )}
    </>
  );
};

ThirdStepComponent.propTypes = {
  openConfirm: PropTypes.object.isRequired,
};

export default ThirdStepComponent;
